import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import Section from "../common/Section";

const ExceptionForm = (props) => {
	const { exception, reactError } = props;
	const datetime = moment();
	const date = datetime.format("DD-MM-YYYY");
	const time = datetime.format("HH:mm:ss");

	let messageType;
	let message;
	if (reactError)
		message = reactError.message;
	else if (exception.response && exception.response.data && exception.response.data.exceptionType) {
		messageType = exception.response.data.exceptionType;
		message = exception.response.data.message;
	} else if (exception.response && exception.response.status) {
		messageType = exception.response.status;
		message = exception.response.statusText;
	} else if (exception.message) {
		message = exception.message;
	} else {
		message = exception;
	}

	return (
		<Section title="Oeps... er ging iets mis...">
			<div className="c-content-block">
				Volgende fout is opgetreden op {date} om {time}:<br />
				<span className="error">
					<span>{messageType}<br /></span><br />
					{message}
				</span>
				<br />
				<br />
					Blijf je problemen ondervinden, neem dan <a href={props.contact} target="_top">contact</a> op met uw dossierbeheerder en bezorg uw dossierbeheerder een kopie van dit scherm zodat we dit probleem verder kunnen onderzoeken.
				</div>
		</Section>
	);
};

ExceptionForm.propTypes = {
	exception: PropTypes.object,
	reactError: PropTypes.object,
	contact: PropTypes.string
};

export default ExceptionForm;
